export enum CalculationSectionType {
    Insurer = "insurer",
    Owner = "owner",
    CoOwner = "coowner",
    User = "user",
    Standalone = "standalone",
}